import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
export function Guarantee() {
  return <section id="garantia" className="border-b border-line bg-ink py-[60px] lg:py-[100px]" data-id="element-129" data-mp="20mei7nt9x04e">
      <Reveal className="mx-auto max-w-2xl px-6 text-center lg:px-10" data-id="element-130" data-mp="24m5eu85heagu">
        <span className="inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-gold/40 bg-line shadow-glow" data-id="element-131" data-mp="29dolw7y0ecmt">
          <ShieldCheckIcon className="h-7 w-7 text-gold" strokeWidth={1.25} aria-hidden="true" data-id="element-132" data-mp="2ec86o50v9idl" />
        </span>
        <h2 className="mt-8 text-3xl font-bold uppercase leading-tight tracking-tight text-gold sm:text-4xl" data-id="element-133" data-mp="2jajfqdjc7our">
          Garantía 7 días — sin preguntas
        </h2>
        <p className="mt-6 text-[17px] leading-[1.7] text-cool" data-id="element-134" data-mp="2sdascgny8qnz">
          Abrís los tomos. Aplicás los protocolos. Si en 7 días no notás una
          diferencia real en tu energía y tu foco, te devolvemos el 100%: sin
          formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 text-[13px] font-medium uppercase tracking-[0.1em] text-gold" data-id="element-135" data-mp="3sl6i9oxqqxr4">
          Tasa de devoluciones: menos del 1%
        </p>
      </Reveal>
    </section>;
}